// @file Network requests related to reaction from surface

import FetchableObject from '@@/surface/api/fetchable_object'
import { fetchJson } from '@@/surface/api_fetch'
import type { AccumulatedReactions, Id } from '@@/types'
import type { JsonAPIResponse, Reaction, ReactionsFetchQuery } from '@padlet/arvo'
import { fetchReactions } from '@padlet/arvo'
import { HTTPMethod } from '@padlet/fetch'

const API_VERSION = 7

export interface CreateOrUpdateReactionPayload {
  postId: Id
  value: number | string
}

export interface ReactionUser {
  user_hashid: string
  username: string | null
  avatar: string
  display_name: string
}

class ReactionApi extends FetchableObject {
  public static async fetchAccumulatedReactions({
    wallId,
  }: {
    wallId: number
  }): Promise<JsonAPIResponse<AccumulatedReactions>> {
    return await fetchJson(`/api/${API_VERSION}/accumulated_reactions?wall_id=${wallId}`, {
      method: HTTPMethod.get,
    })
  }

  public static get url(): string {
    return `/api/${API_VERSION}/reactions`
  }

  public static get fetchUrl(): string {
    return `/api/${API_VERSION}/reactions?wall_id=\${ wall.id }`
  }

  public static async fetch(query: ReactionsFetchQuery): Promise<JsonAPIResponse<Reaction>> {
    return await fetchReactions(query)
  }

  public static async fetchUsersThatReactedToWish({
    wishHashId,
    value,
    cursor,
  }: {
    wishHashId: string
    value?: CreateOrUpdateReactionPayload['value']
    cursor?: string
  }): Promise<{
    data: ReactionUser[]
    pagination: { has_more: boolean; next_cursor: string | null; previous_cursor: string | null }
  }> {
    const params = new URLSearchParams({
      wish_hashid: wishHashId,
      ...(value != null ? { value: String(value) } : {}),
      ...(cursor != null ? { cursor } : {}),
    })

    return await fetchJson(`/api/${API_VERSION}/reactions/users?${params.toString()}`, {
      method: HTTPMethod.get,
    })
  }
}

export { ReactionApi }
